/* eslint-disable no-unreachable */
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { doFetch } from "../../../lib/doFetch";
import { useIsPublicPage } from "../../../lib/routing";
import { miscSlice } from "redux/slices/miscSlice";
import { features } from "app/features";

// export const ADVERTS_URL = "/research/japi/content/advert";
export const ADVERTS_URL = "/research/japi/content/advert2";
const ADVERT_STYLES_URL = "/research/japi/content/assets/static/advertStyles.json";
const LEGACY_ADVERTS_URL = process.env.PUBLIC_URL + "/api/adverts/adverts.json";
const LEGACY_ADVERT_STYLES_URL = process.env.PUBLIC_URL + "/api/adverts/advertStyles.json";
const IMAGE_URL = "/research/japi/content/assets/banners/";

export const AdvertProvider = () => {
  const isPublicPage = useIsPublicPage();
  return !isPublicPage ? <AdvertFetcher /> : null;
};

export const AdvertFetcher = () => {
  const dispatch = useDispatch();
  const advertsUrl = features.useContentAPIForAdverts ? ADVERTS_URL : LEGACY_ADVERTS_URL;
  const advertStylesUrl = features.useContentAPIForAdvertStyles ? ADVERT_STYLES_URL : LEGACY_ADVERT_STYLES_URL;

  useEffect(() => {
    const doAdvertsFetch = async () => {
      try {
        const styles = await doFetch(advertStylesUrl, null, "GET");
        dispatch(miscSlice.actions.set({ key: "advertStyles", value: styles }));

        const adverts = await doFetch(advertsUrl, null, "GET");
        const parsedAdverts = tryParse(adverts);
        if (parsedAdverts) dispatch(miscSlice.actions.set({ key: "adverts", value: parsedAdverts }));
      } catch (err) {
        console.error("error could not load adverts", err); // do not show GUI message
      }
    };
    doAdvertsFetch();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};

// correct malformed image URLs from server
function tryParse(adverts) {
  if (!adverts || !adverts.data) return null;

  let parsedAdverts = null;
  try {
    parsedAdverts = adverts.data.map(fixImgUrls);
  } catch (err) {
    console.error("Could not parse adverts", err);
  }

  return parsedAdverts;
}

const fixImgUrls = (advert) => ({
  ...advert,
  img: prependImageUrl(advert.img),
  mobileImg: prependImageUrl(advert.mobileImg),
  leftImg: prependImageUrl(advert.leftImg),
  rightImg: prependImageUrl(advert.rightImg),
});

const prependImageUrl = (url) => (url ? IMAGE_URL + url : null);
